<template>
  <!--
    右侧悬浮工具条 + 客服电话弹窗（2026-09-16 第五轮重做）
    之前的问题：
      1. 定位写死 left:1616px，屏幕不是 1920 就跑偏（改成 right 贴边）
      2. 电话弹窗就是两行 30px 黑字，没有任何设计感
      3. 号码只在 mounted 时读 sessionStorage，直接进页面时可能是空的 → 补了接口兜底
    这个组件被 12 个页面引用（会员福利 / 个人中心 / 订单 / 404 …），改一处全站生效。
  -->
  <div class="recharge-subscript">
    <button
      class="fab-item"
      type="button"
      ref="imgLI"
      :title="SettingListCC || '客服热线'"
      @click="outboundClick"
    >
      <img src="../image/weichongzhi/icon_一键智能外呼.png" alt="一键智能外呼"/>
      <span class="fab-tip">客服热线</span>
    </button>

    <span class="fab-line"></span>

    <button class="fab-item" type="button" title="AI 智能助手" @click="chatGptClick">
      <img src="../image/weichongzhi/icon_AI智能助手.png" alt="AI 智能助手"/>
      <span class="fab-tip">AI 助手</span>
    </button>

    <!--
      ⚠️ append-to-body 是**必须**的，不是可选优化：
      本组件根元素 .recharge-subscript 上有 `transform: translateY(-50%)`，
      而按 CSS 规范，**带 transform 的祖先会成为 position:fixed 后代的包含块**。
      el-dialog 默认 append-to-body:false，弹窗留在原地 →
      它的 .el-dialog__wrapper（position:fixed; left:0; right:0）
      就被困在这个 62px 宽的小胶囊里，结果要么被裁切、要么整个看不见，
      表现就是「点了图标像没反应」。
      挂到 <body> 下就彻底脱离这个包含块，定位恢复正常。
    -->
    <el-dialog
      :visible.sync="dialogVisible4"
      width="420px"
      :modal="model"
      :show-close="false"
      custom-class="yyq-phone-dialog"
      append-to-body
      @closed="handleClose4"
    >
      <div class="phone-card">
        <!-- 顶部：渐变头像 + 脉冲光环，给弹窗一点"活气" -->
        <div class="phone-head">
          <div class="phone-icon">
            <span class="phone-ring"></span>
            <i class="el-icon-phone-outline"></i>
          </div>
          <div class="phone-title">欢迎拨打客服热线</div>
          <div class="phone-sub">工作日 9:00 - 18:00 · 人工客服为您服务</div>
        </div>

        <!-- 号码：大号 + 字距拉开，点击即复制 -->
        <div class="phone-number" @click="copyTel" :title="'点击复制：' + telText">
          {{ telText }}
        </div>

        <div class="phone-actions">
          <a class="phone-btn primary" :href="'tel:' + telHref">
            <i class="el-icon-phone"></i>
            <span>立即拨打</span>
          </a>
          <button class="phone-btn" type="button" @click="copyTel">
            <i class="el-icon-document-copy"></i>
            <span>{{ copied ? "已复制" : "复制号码" }}</span>
          </button>
        </div>

        <div class="phone-close" @click="dialogVisible4 = false">关闭</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { corporateSettingApi } from "@/api/toolApi";

export default {
  name: "felixItem",
  data() {
    return {
      SettingListCC: "",
      dialogVisible4: false,
      model: false, // 不加遮罩：悬浮工具条本来就是不打断操作的
      copied: false,
    };
  },
  computed: {
    /* 没拿到配置时给个兜底号码，避免弹窗里一片空白 */
    telText() {
      return this.SettingListCC || "400-156-9098";
    },
    /*
     * tel: 链接只认数字、+ 和 -，中文和空格要去掉。
     * 不用正则的 [^\d+\-] 写法：字符类里的 \- 会被 eslint 的 no-useless-escape 判为多余转义，
     * 而本项目把 lint 当 error，会直接编译失败。改成逐字符过滤，一样的效果、不踩规则。
     */
    telHref() {
      return String(this.telText)
        .split("")
        .filter((c) => (c >= "0" && c <= "9") || c === "+" || c === "-")
        .join("");
    },
  },
  mounted() {
    this.SettingListCt();
  },
  methods: {
    chatGptClick() {
      this.$router.push("/chatGptS");
    },
    //一键外呼
    outboundClick() {
      this.dialogVisible4 = true;
      this.copied = false;
    },
    SettingListCt() {
      let ct = sessionStorage.getItem("SettingList");
      if (ct) {
        try {
          this.SettingListCC = JSON.parse(ct).company_tel || "";
        } catch (e) {
          this.SettingListCC = "";
        }
      }
      // 兜底：直接落在这个页面时 sessionStorage 还没写，自己拉一次
      if (!this.SettingListCC) {
        corporateSettingApi({}).then((res) => {
          if (res && res.code === 0 && res.data) {
            this.SettingListCC = res.data.company_tel || "";
            sessionStorage.setItem("SettingList", JSON.stringify(res.data));
          }
        });
      }
    },
    copyTel() {
      const text = this.telText;
      const done = () => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1800);
      };
      // navigator.clipboard 只在 https 下可用，本地 http 要退回 execCommand
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done));
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy(text, done) {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        done();
      } catch (e) {
        /* 复制失败也不影响使用，号码本来就在页面上 */
      }
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* ---------------- 右侧悬浮条 ----------------
   ⚠️ 选择器写两遍 .recharge-subscript.recharge-subscript 是有意的：
   Vue 的 scoped 会把**父组件**的 data-v-xxx 加到子组件根元素上，
   于是 VIP.vue / recharge.vue 这些页面自己写的 .recharge-subscript[data-v-页面]
   （里面是写死的 left:1616px; top:604px）会和本组件的规则撞车、特异性还一样。
   类名重复一次 → 特异性变成 0,3,0 压过它们的 0,2,0。
   另外必须显式写 left:auto，否则父级的 left 和这里的 right 同时存在时，
   LTR 下 left 优先，right 等于没写。 */
.recharge-subscript.recharge-subscript {
  position: fixed;
  left: auto;
  right: 24px;
  top: 58%;
  transform: translateY(-50%);
  /* ⚠️ z-index 原来只有 90：页面上任何层级更高的固定/绝对定位元素都会盖住它，
     表现就是「图标看得见、点下去没反应」。抬到 1800 ——
     高于普通页面内容，又仍低于 Element PopupManager 给弹窗分配的 2000+，不会反过来盖住弹窗。 */
  z-index: 1800;

  display: flex;
  /* ⚠️ 保持原来的 column-reverse：DOM 里是「外呼 → AI 助手」，
     反转后渲染成「AI 助手在上 / 外呼在下」。
     用户说的「点下面那个弹电话」指的就是外呼，改成 column 会把它翻到上面去。 */
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 10px;

  box-sizing: border-box;
  width: 62px;
  padding: 14px 0;
  background: linear-gradient(180deg, #ffffff 0%, #f7f8fd 100%);
  box-shadow: 0 12px 28px rgba(31, 34, 51, 0.12);
  border: 1px solid #e6e8f2;
  border-radius: 31px;

  .fab-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;
    transition: background 0.22s ease, transform 0.22s ease, box-shadow 0.22s ease;

    img {
      width: 30px;
      height: 30px;
      display: block;
    }

    &:hover {
      background: rgba(72, 52, 212, 0.09);
      transform: translateY(-2px);
      box-shadow: 0 6px 14px rgba(72, 52, 212, 0.18);
    }

    /* 悬停时在左边冒出文字提示 */
    .fab-tip {
      position: absolute;
      right: 52px;
      white-space: nowrap;
      padding: 5px 12px;
      border-radius: 999px;
      background: #2b2f3a;
      color: #fff;
      font-size: 13px;
      line-height: 1.4;
      opacity: 0;
      transform: translateX(6px);
      pointer-events: none;
      transition: opacity 0.22s ease, transform 0.22s ease;
    }

    &:hover .fab-tip {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .fab-line {
    width: 26px;
    height: 1px;
    background: #e6e8f2;
  }
}

/* ---------------- 电话弹窗 ---------------- */
.phone-card {
  padding: 8px 4px 4px;
  text-align: center;
}

.phone-head {
  .phone-icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4834d4 0%, #6c5ce7 100%);
    box-shadow: 0 10px 24px rgba(72, 52, 212, 0.32);

    i {
      font-size: 30px;
      color: #fff;
    }

    /* 外扩的脉冲光环 */
    .phone-ring {
      position: absolute;
      inset: -6px;
      border-radius: 50%;
      border: 2px solid rgba(72, 52, 212, 0.35);
      animation: yyq-ring 1.8s ease-out infinite;
    }
  }

  .phone-title {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 700;
    color: #1f2233;
    letter-spacing: 0.5px;
  }

  .phone-sub {
    margin-top: 6px;
    font-size: 13px;
    color: #9aa0b4;
  }
}

.phone-number {
  margin: 22px 0 20px;
  padding: 14px 12px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f6f5ff 0%, #eef1ff 100%);
  border: 1px dashed #cfc9f5;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #4834d4;
  cursor: pointer;
  user-select: all;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(72, 52, 212, 0.14);
  }
}

.phone-actions {
  display: flex;
  gap: 12px;

  .phone-btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-sizing: border-box;
    height: 44px;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.22s ease;

    i {
      font-size: 16px;
    }
  }

  .phone-btn.primary {
    color: #fff;
    background: linear-gradient(135deg, #4834d4 0%, #6c5ce7 100%);
    box-shadow: 0 8px 18px rgba(72, 52, 212, 0.28);

    &:hover {
      filter: brightness(1.06);
      transform: translateY(-1px);
    }
  }

  .phone-btn:not(.primary) {
    color: #5f6478;
    background: #f4f5fb;
    border: 1px solid #e3e6f0;

    &:hover {
      color: #4834d4;
      border-color: #c9c4f5;
      background: #fbfbff;
    }
  }
}

.phone-close {
  margin: 16px 0 4px;
  font-size: 13px;
  color: #9aa0b4;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #4834d4;
  }
}

@keyframes yyq-ring {
  0% {
    transform: scale(0.96);
    opacity: 0.9;
  }
  70% {
    transform: scale(1.18);
    opacity: 0;
  }
  100% {
    transform: scale(1.18);
    opacity: 0;
  }
}
</style>

<!--
  custom-class 作用在 .el-dialog 上，它是挂到 body 的，
  所以这条规则不能写在 scoped 里（scoped 只管本组件的 DOM）。
-->
<style lang="scss">
.yyq-phone-dialog {
  border-radius: 18px !important;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 30px 28px 22px;
  }
}
</style>
